import type { CapabilityArea } from './capabilities.js';

export type MobileRouteShell = 'root' | 'stack' | 'task' | 'immersive' | 'module';

export interface MobileRouteMeta {
	pattern: RegExp;
	titleKey: string;
	area: CapabilityArea;
	shell: MobileRouteShell;
	capabilityKey?: string;
	hideBottomTab?: boolean;
}

export const MOBILE_ROUTE_META: MobileRouteMeta[] = [
	{ pattern: /^\/m\/monitor$/, titleKey: 'tabbar.monitor', area: 'monitor', shell: 'root', capabilityKey: 'monitor' },
	{ pattern: /^\/m\/video$/, titleKey: 'tabbar.monitor', area: 'monitor', shell: 'root', capabilityKey: 'monitor' },
	{ pattern: /^\/m\/video\/[^/]+/, titleKey: 'tabbar.monitor', area: 'monitor', shell: 'stack', capabilityKey: 'store' },
	{ pattern: /^\/m\/player(?:$|\?)/, titleKey: 'tabbar.monitor', area: 'monitor', shell: 'immersive', capabilityKey: 'monitor', hideBottomTab: true },
	{ pattern: /^\/m\/multi-(select|view)\/[^/]+/, titleKey: 'store_detail.multi_view', area: 'monitor', shell: 'immersive', capabilityKey: 'monitor', hideBottomTab: true },

	{ pattern: /^\/m\/incidents$/, titleKey: 'tabbar.incidents', area: 'incidents', shell: 'root', capabilityKey: 'incidents' },
	{ pattern: /^\/(event|alert|message)$/, titleKey: 'tabbar.incidents', area: 'incidents', shell: 'module' },

	{ pattern: /^\/m\/analytics$/, titleKey: 'tabbar.analytics', area: 'analytics', shell: 'root', capabilityKey: 'analytics' },
	{ pattern: /^\/(customer|member|traffic|cloudstorage)$/, titleKey: 'tabbar.analytics', area: 'analytics', shell: 'module' },

	{ pattern: /^\/m\/operations$/, titleKey: 'tabbar.operations', area: 'operations', shell: 'root', capabilityKey: 'operations' },
	{ pattern: /^\/m\/workbench$/, titleKey: 'tabbar.operations', area: 'operations', shell: 'root', capabilityKey: 'operations' },
	{ pattern: /^\/m\/application\/display$/, titleKey: 'tabbar.application', area: 'operations', shell: 'task', capabilityKey: 'operations', hideBottomTab: true },
	{ pattern: /^\/m\/application\/native-gate\/[^/]+$/, titleKey: 'tabbar.application', area: 'operations', shell: 'task', capabilityKey: 'operations', hideBottomTab: true },
	{ pattern: /^\/m\/snapshot-inspection$/, titleKey: 'tabbar.application', area: 'operations', shell: 'task', capabilityKey: 'operations', hideBottomTab: true },
	{ pattern: /^\/inspect$/, titleKey: 'native.inspect.title', area: 'operations', shell: 'task', capabilityKey: 'operations', hideBottomTab: true },
	{ pattern: /^\/(patrol|aipatrol|scan|sharedevice|pos|smart-listening|phonelive)$/, titleKey: 'tabbar.operations', area: 'operations', shell: 'module' },

	{ pattern: /^\/m\/account$/, titleKey: 'tabbar.account', area: 'account', shell: 'root', capabilityKey: 'account' },
	{ pattern: /^\/m\/profile$/, titleKey: 'tabbar.account', area: 'account', shell: 'root', capabilityKey: 'account' },
	{ pattern: /^\/m\/profile-edit$/, titleKey: 'mtab.profile.edit_profile', area: 'account', shell: 'task', capabilityKey: 'account', hideBottomTab: true },
	{ pattern: /^\/m\/repair(?:$|\?)/, titleKey: 'repair.title', area: 'account', shell: 'task', capabilityKey: 'account', hideBottomTab: true },
	{ pattern: /^\/m\/repair-list(?:$|\?)/, titleKey: 'repair.history', area: 'account', shell: 'stack', capabilityKey: 'account' },
	{ pattern: /^\/m\/(recent|album|hotline|feedback|changelog)$/, titleKey: 'tabbar.account', area: 'account', shell: 'stack', capabilityKey: 'account' },
];

export function getMobileRouteMeta(pathname: string): MobileRouteMeta | undefined {
	return MOBILE_ROUTE_META.find((meta) => meta.pattern.test(pathname));
}

export function routeHidesBottomTab(pathname: string): boolean {
	const meta = getMobileRouteMeta(pathname);
	return Boolean(meta?.hideBottomTab || meta?.shell === 'immersive' || meta?.shell === 'task');
}
